import { render } from "./JerarquiaCreate.vue?vue&type=template&id=0c969fee"
import script from "./JerarquiaCreate.vue?vue&type=script&lang=js"
export * from "./JerarquiaCreate.vue?vue&type=script&lang=js"

import "./JerarquiaCreate.vue?vue&type=style&index=0&id=0c969fee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__